<template>
  <div
    class="tool-icon mwe-area render-tool"
    :style="{
      ...texteditor.selectionIcon.toolbar.position,
    }"
  >
    <div class="d-flex align-items-center" style="width: max-content; gap: 10px;">
      <IconBrowse @submit="changeIcon" @open="onIconOpen" @close="onIconClose" />
      <LineVertical/>
      <Size :value="iconSize" :optionSize="'textIcon'" @change="changeSize" />
      <LineVertical/>
      <Color :value="iconColor" @change="changeColor" v-if="selectionFormatMerge.iconFillable"/>
      <Link :value="iconLink" @open="onLinkOpen" @close="onLinkClose" @save="onLinkSave" @unlink="onUnlink"/>
      <Remove @click="remove"/>
      <Close @click="$emit('close')"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LineVertical from "@components_system/Shared/Floatframe/Tools/LineVertical";
import IconBrowse from "@components_system/Shared/Floatframe/Tools/IconBrowse";
import Size from "@components_system/Shared/Floatframe/Tools/Size";
import Color from "@components_system/Shared/Floatframe/Tools/Color";
import Link from "@components_system/Shared/Floatframe/Tools/Link";
import Remove from "@components_system/Shared/Floatframe/Tools/Remove";
import Close from "@components_system/Shared/Floatframe/Tools/Close";

import colorhelper from "@helpers/color.helper";

export default {
  components: {
    LineVertical,
    IconBrowse,
    Size,
    Color,
    Link,
    Remove,
    Close,
  },
  data() {
    return {
      iconDefault: {
        "data": {
            "id": "25",
            "name": "profit",
            "content": "<svg id=\"Capa_1\" enable-background=\"new 0 0 512 512\" height=\"512\" viewBox=\"0 0 512 512\" width=\"512\" xmlns=\"http://www.w3.org/2000/svg\"><g><path d=\"m129.894 49.455c-17.485 0-31.71 14.225-31.71 31.71s14.225 31.711 31.71 31.711 31.711-14.226 31.711-31.711-14.226-31.71-31.711-31.71zm0 48.421c-9.214 0-16.71-7.496-16.71-16.711 0-9.214 7.496-16.71 16.71-16.71 9.215 0 16.711 7.496 16.711 16.71-.001 9.215-7.497 16.711-16.711 16.711z\"/><path d=\"m161.604 223.205v-28.991c0-4.143-3.357-7.5-7.5-7.5h-76.394c-4.143 0-7.5 3.357-7.5 7.5v28.991c0 4.143 3.357 7.5 7.5 7.5h76.395c4.142 0 7.499-3.357 7.499-7.5zm-15-7.5h-61.394v-13.991h61.395v13.991z\"/><path d=\"m477.761 62.258h-47.607c-8.291 0-15.522 4.614-19.268 11.407h-199.827v-4.755c0-3.547-2.484-6.608-5.955-7.339l-18.276-3.848c-.033-.08-.066-.16-.1-.24l10.203-15.644c1.938-2.971 1.529-6.893-.979-9.4l-17.331-17.332c-2.508-2.508-6.429-2.918-9.401-.979l-15.645 10.204c-.08-.033-.159-.066-.239-.1l-3.848-18.277c-.73-3.471-3.792-5.955-7.339-5.955h-24.511c-3.547 0-6.608 2.484-7.339 5.955l-3.848 18.277c-.08.033-.159.066-.239.1l-15.644-10.204c-2.971-1.938-6.893-1.527-9.401.979l-17.332 17.331c-2.508 2.509-2.916 6.431-.979 9.401l10.204 15.645c-.033.08-.066.159-.1.239l-18.277 3.848c-3.471.73-5.955 3.792-5.955 7.339v4.755h-.199c-19.897 0-36.086 16.188-36.086 36.086v233.303c0 19.897 16.188 36.086 36.086 36.086h28.414c3.626 26.133 26.578 45.974 52.948 45.974 7.776 0 15.161-1.682 21.833-4.678l-16.963 66.374c-6.736 26.352 35.249 35.304 41.72 10l30.074-117.668h24.417v112.668c0 10.981 9.211 20.191 20.191 20.191 10.982 0 20.191-9.21 20.191-20.191v-112.67h24.419l30.073 117.667c6.465 25.299 48.458 16.362 41.72-9.999l-27.516-107.668h113.75c19.897 0 36.086-16.188 36.086-36.086v-162.054c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v162.054c0 11.627-9.459 21.086-21.086 21.086l-270.965.001c-3.659-25.946-26.001-45.974-52.943-45.974-26.371 0-49.322 19.837-52.948 45.973h-28.415c-11.627 0-21.086-9.459-21.086-21.086v-217.835h34.232c.145 1.717.869 3.383 2.16 4.674l17.332 17.331c2.507 2.506 6.427 2.917 9.4.979l15.644-10.204c.08.033.16.066.24.1l3.848 18.277c.73 3.471 3.792 5.955 7.339 5.955h24.511c3.547 0 6.608-2.484 7.339-5.955l3.848-18.277c.08-.033.16-.066.24-.1l15.644 10.204c2.973 1.939 6.895 1.528 9.401-.979l17.331-17.331c1.291-1.291 2.014-2.957 2.159-4.674h207.368l-69.917 69.917-35.912-35.902c-5.59-5.614-14.877-5.611-20.475-.011l-23.314 23.313c-2.93 2.929-2.93 7.678-.001 10.606s7.678 2.93 10.606.001l22.941-22.939 35.923 35.914c5.593 5.589 14.876 5.606 20.465-.001l102.068-102.069c2.145-2.146 2.786-5.371 1.625-8.174-1.16-2.803-3.896-4.63-6.929-4.63h-12.407c-9.02 0-9.011-13.986 0-13.986h47.607c3.747 0 6.796 3.044 6.796 6.785v47.607c0 3.819-3.181 6.999-6.999 6.999-3.858 0-6.998-3.14-6.998-6.999v-12.396c0-3.033-1.827-5.769-4.63-6.929-2.803-1.163-6.028-.52-8.173 1.625l-122.188 122.178-35.927-35.918c-5.634-5.632-14.809-5.635-20.466.001l-61.553 61.563c-6.301 6.311-16.277-3.503-9.888-9.897l33.738-33.736c2.929-2.93 2.929-7.678 0-10.607-2.929-2.927-7.678-2.929-10.606 0l-33.738 33.736c-8.739 8.741-8.38 23.322.644 31.701 8.543 7.933 22.224 7.659 30.463-.595l61.174-61.183 35.923 35.913c5.569 5.588 14.888 5.608 20.464.01l110.363-110.354c2.31 9.674 11.028 16.889 21.399 16.889 11.982 0 21.999-10.014 21.999-21.999v-47.609c.001-12.013-9.777-21.785-21.795-21.785zm-315.813 430.835c-1.663 6.507-14.544 4.823-12.653-2.569l21.631-84.638c6.244-7.468 10.485-16.658 11.908-26.745h8.239zm94.407-1.284c0 6.679-10.383 6.69-10.383 0v-112.669h10.383zm96.679-1.286c1.886 7.375-10.991 9.071-12.653 2.57l-29.124-113.953h13.311zm-231.826-156.376c2.836-.65 5.758-.98 8.684-.98 21.214 0 38.472 17.252 38.479 38.46l-.001.013.001.013c-.007 21.208-17.266 38.46-38.479 38.46-21.05 0-38.473-17.441-38.473-38.474 0-18.033 12.253-33.451 29.789-37.492zm-93.765-224.396c0-11.627 9.459-21.086 21.086-21.086h.199v4.756c0 3.547 2.484 6.608 5.955 7.339l18.277 3.848c.033.08.066.159.1.239l-3.504 5.372h-42.113zm144.874 22.562-14.011-9.139c-5.088-3.316-17.563 1.918-18.798 7.79l-3.445 16.365h-12.339l-3.445-16.365c-1.25-5.944-13.773-11.067-18.798-7.79l-14.011 9.139-8.726-8.725 9.139-14.011c3.315-5.087-1.917-17.563-7.789-18.798l-16.366-3.445v-12.338l16.366-3.445c5.945-1.25 11.064-13.773 7.789-18.798l-9.139-14.011 8.726-8.726 14.011 9.139c5.087 3.316 17.563-1.917 18.798-7.789l3.446-16.366h12.339l3.445 16.366c1.25 5.944 13.773 11.065 18.798 7.789l14.011-9.139 8.725 8.726-9.139 14.011c-3.317 5.086 1.919 17.564 7.79 18.798l16.365 3.445v12.339l-16.365 3.445c-5.943 1.249-11.067 13.774-7.79 18.798l9.139 14.011zm252.73-26.662-4.567 4.567h-230.249l-3.503-5.371c.033-.08.066-.16.1-.24l18.276-3.848c3.471-.73 5.955-3.792 5.955-7.339v-4.756h197.551c1.676 8.273 8.221 15.044 16.437 16.987z\"/><path d=\"m436.723 314.018h-142.143c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h142.143c4.143 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5z\"/><path d=\"m436.723 281.113h-84.271c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h84.271c4.143 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5z\"/><path d=\"m77.71 244.189c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h52.184c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5z\"/><path d=\"m129.895 389.254c4.143 0 7.5-3.357 7.5-7.5v-20.228c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v20.228c0 4.142 3.357 7.5 7.5 7.5z\"/></g></svg>",
            "type": "icon"
        }
      },
      formatLinkClear: {
        linkType: false,
        linkTarget: false,
        link: false,
        linkPageID: false,
        linkSectionID: false,
        linkFileID: false,
        linkFileName: false,
        linkPhoneCode: false,

        linkTypeOld: false,
        linkPageIdOld: false,
        linkSectionIdOld: false,
        linkDocNameOld: false,
        phoneCodeOld: false,

        underline: false,
        decoration: false,
      }
    };
  },
  computed: {
    ...mapGetters({
      languageUse: "designIframe/metadata/siteActiveLanguage",
      texteditor: "designIframe/texteditor/texteditor",
      siteComponents: "designIframe/metadata/siteComponents",
    }),
    selectionFormatMerge() {
      return this.texteditor.selectionFormatMerge;
    },
    iconContent() {
      return this.selectionFormatMerge.iconContent || this.selectionFormatMerge.iconContent;
    },
    iconName() {
      return this.selectionFormatMerge.iconName || this.selectionFormatMerge.iconName;
    },
    iconSize() {
      return this.selectionFormatMerge.iconSize || this.selectionFormatMerge.iconSize;
    },
    iconColor() {
      return this.selectionFormatMerge.iconColor || this.selectionFormatMerge.iconColor;
    },
    iconLink() {
      return this.convertFormatToLinkValue(this.selectionFormatMerge);
    },
  },
  methods: {
    // Icon
    onIconOpen() {
      this.$store.dispatch("designIframe/texteditor/setData", { forceFocus: true });
    },
    onIconClose() {
      this.$store.dispatch("designIframe/texteditor/setData", { forceFocus: false });
    },
    changeIcon(value) {
      if (!value) value = this.iconDefault;

      const selection = this.texteditor.editor.getSelection();
      const selectionFormatMerge = this.selectionFormatMerge;
      let content = value ? value.data.content : null;
      let name = value ? value.data.name : '';
      let size = Array.isArray(selectionFormatMerge.iconSize) ? selectionFormatMerge.iconSize[0] 
                : selectionFormatMerge.iconSize ? selectionFormatMerge.iconSize
                : selectionFormatMerge.size;
      let color = Array.isArray(selectionFormatMerge.iconColor) ? selectionFormatMerge.iconColor[0] 
                : selectionFormatMerge.iconColor ? selectionFormatMerge.iconColor
                : selectionFormatMerge.color;

      this.texteditor.editor.insertEmbed(selection.index, 'icon', {
        content: content,
        name: name,
        size: size,
        color: color,
      });
      this.texteditor.editor.deleteText(selection.index + 1, 1);
      // this.texteditor.editor.setSelection(selection.index, 1); // selection current

      this.texteditor.editor.setSelection(selection.index + 1, 0); // selection current
      this.$emit('close');
    },

    // Color
    changeColor(value) {
      const selection = this.texteditor.editor.getSelection();
      const selectionFormatMerge = this.selectionFormatMerge;
      let size = Array.isArray(selectionFormatMerge.iconSize) ? selectionFormatMerge.iconSize[0] 
                : selectionFormatMerge.iconSize ? selectionFormatMerge.iconSize
                : selectionFormatMerge.size;
      let color = colorhelper.getColor(value);

      this.texteditor.editor.insertEmbed(selection.index, 'icon', {
        content: selectionFormatMerge.iconContent,
        name: selectionFormatMerge.iconName,
        size: size,
        color: color,
      });
      this.texteditor.editor.deleteText(selection.index + 1, 1);
      // this.texteditor.editor.setSelection(selection.index, 1); // selection current

      this.texteditor.editor.setSelection(selection.index + 1, 0); // selection current
      this.$emit('close');
    },
    
    // Size
    async changeSize(value) {
      const selection = this.texteditor.editor.getSelection();
      const selectionFormatMerge = this.selectionFormatMerge;
      let size = `${value}px`;
      let color = Array.isArray(selectionFormatMerge.iconColor) ? selectionFormatMerge.iconColor[0] 
                : selectionFormatMerge.iconColor ? selectionFormatMerge.iconColor
                : selectionFormatMerge.color;

      this.texteditor.editor.insertEmbed(selection.index, 'icon', {
        content: selectionFormatMerge.iconContent,
        name: selectionFormatMerge.iconName,
        size: size,
        color: color,
      });
      this.texteditor.editor.deleteText(selection.index + 1, 1);
      // this.texteditor.editor.setSelection(selection.index, 1); // selection current
      // await this.$store.dispatch("designIframe/texteditor/setSelectionIcon", { target: node }); // setup icon target
      // await this.$store.dispatch("designIframe/texteditor/reIconFrame");
      // this.$store.dispatch("designIframe/texteditor/reIconToolbar");

      this.texteditor.editor.setSelection(selection.index + 1, 0); // selection current
      this.$emit('close');
    },

    // Link
    convertFormatToLinkValue(value) {
      const type = (value.linkType || value.linkTypeOld) || 
        (value.link && value.link.includes('http') && 'url') || 
        (value.link && value.link.includes('https') && 'url') || 
        (value.link && value.link.includes('mailto') && 'email') || 
        (value.link && value.link.includes('tel') && 'phone') ||
        (value.link && 'url') ||
        undefined;
      return {
        type: type,
        target: value.linkTarget,
        url: 
          (type == 'url') ? value.link : undefined,
        pageID: 
          (type == 'page') ? value.linkPageID || value.linkPageIdOld : undefined,
        sectionPageID: 
          (type == 'anchor') ? value.linkPageID || value.linkPageIdOld : undefined,
        sectionID: 
          (type == 'page' || type == 'anchor') ? value.linkSectionID : undefined,
        email: 
          (type == 'email') ? value.link.replace('mailto:', '').replace(/\?subject=.*/, '').trim() : undefined,
        emailSubject: 
          (type == 'email') ? decodeURIComponent(value.link.substring(value.link.indexOf('?subject='), value.link.length).replace('?subject=', '').trim()) : undefined,
        phone: 
          (type == 'phone') ? value.link.replace('tel:', '').trim() : undefined,
        phoneCountry: 
          (type == 'phone') ? value.linkPhoneCode || value.phoneCodeOld : undefined,
        phoneFormat: 
          (type == 'phone') ? null : undefined,
        fileID: 
          (type == 'file') ? value.linkFileID : undefined,
        fileName: 
          (type == 'file') ? value.linkFileName : undefined,
        fileUrl: 
          (type == 'file') ? value.link.trim() : undefined,
      }
    },
    convertLinkValueToFormat(value) {
      switch (value.linkType) {
        case 'url': return {
          ...this.formatLinkClear,
          linkType: 'url',
          linkTarget: value.target,
          link: this.$helper.url.genValidUrl(value.url),
          
          underline: false,
          decoration: this.selectionFormatMerge.isIcon ? false : 'underline',
        }
        case 'page': return {
          ...this.formatLinkClear,
          linkType: 'page',
          linkTarget: value.target,
          linkPageID: value.pageID,
          link: value.sectionPageID ? this.genUrlPage(value.sectionPageID, value.sectionID, this.languageUse) : '',
          
          underline: false,
          decoration: this.selectionFormatMerge.isIcon ? false : 'underline',
        }
        case 'anchor': return {
          ...this.formatLinkClear,
          linkType: 'anchor',
          linkTarget: '_self',
          linkPageID: value.sectionPageID,
          linkSectionID: value.sectionID,
          link: `mailto:${value.email}?subject=${encodeURIComponent(value.emailSubject ? value.emailSubject : "")}`,
          
          underline: false,
          decoration: this.selectionFormatMerge.isIcon ? false : 'underline',
        }
        case 'email': return {
          ...this.formatLinkClear,
          linkType: 'email',
          linkTarget: '_self',
          link: `mailto:${value.email}?subject=${encodeURIComponent(value.emailSubject ? value.emailSubject : "")}`,
          
          underline: false,
          decoration: this.selectionFormatMerge.isIcon ? false : 'underline',
        }
        case 'phone': return {
          ...this.formatLinkClear,
          linkType: 'phone',
          linkTarget: '_self',
          linkPhoneCode: value.phoneCountry,
          link: `tel:${value.phone}`,
          
          underline: false,
          decoration: this.selectionFormatMerge.isIcon ? false : 'underline',
        }
        case 'file': return {
          ...this.formatLinkClear,
          linkType: 'file',
          linkTarget: '_blank',
          linkFileID: value.file.id,
          linkFileName: value.file.name,
          link: value.file.url,
          
          underline: false,
          decoration: this.selectionFormatMerge.isIcon ? false : 'underline',
        }
        default: return this.formatLinkClear;
      }
    },
    genUrlPage(pageID, sectionID = null, language = null) {
      const cmpPage = this.siteComponents[pageID];
      let value = '';
      value += language ? `/${language}` : '';
      value += '';
      value += (cmpPage && cmpPage.properties.url) ? `/${cmpPage.properties.url}` : '/undefined';
      value += sectionID ? `#${sectionID}` : '';
      return value;
    },
    onLinkOpen() {
      this.$store.dispatch("designIframe/texteditor/setData", { forceFocus: true });
    },
    onLinkClose() {
      this.$store.dispatch("designIframe/texteditor/setData", { forceFocus: false });
    },
    onLinkSave(value) {
      const selection = this.texteditor.editor.getSelection();
      const formatValues = this.convertLinkValueToFormat(value);

      this.texteditor.editor.formatText(selection, formatValues);
    },
    onUnlink() {
      const selection = this.texteditor.editor.getSelection();
      this.texteditor.editor.formatText(selection, this.formatLinkClear);
    },

    // Remove
    remove() {
      const selection = this.texteditor.editor.getSelection();
      this.texteditor.editor.deleteText(selection);

      this.texteditor.editor.setSelection(selection.index, 0); // selection current
      this.$emit('close');
    },
  },
  
};
</script>

<style scoped>
.tool-icon {
  position: absolute;
  padding: 0 15px;
  border: 1px solid #dee3e6;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);
  border-radius: 20px;
  background: #ffffff;
  align-items: center;
}
</style>
